import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import App from './App';
import Home from './pages/home';
import Web from './pages/web';
import Mobile from './pages/mobile';
import Portfolio from './pages/portfolio';
import About from './pages/about';
import Vacancies from './pages/vacancies';
import Contacts from './pages/contacts';
import Blog from './pages/blog';
import Article from './pages/article';
import Agreements from './pages/agreements';
import Usage from './pages/usage';

export default () => (
  <App>
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/web" component={Web} />
      <Route path="/mobile" component={Mobile} />
      <Route path="/portfolio/:current" component={Portfolio} />
      <Route path="/portfolio" component={Portfolio} />
      <Route path="/about" component={About} />
      <Route path="/vacancies" component={Vacancies} />
      <Route path="/contacts" component={Contacts} />
      <Route path="/blog" exact component={Blog} />
      <Route path="/blog/:article" component={Article} />
      <Route path="/agreements" component={Agreements} />
      <Route path="/usage" component={Usage} />
      <Redirect to="/" />
    </Switch>
  </App>
)



// WEBPACK FOOTER //
// ./src/routes.jsx